import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  addActiveFn,
  pushWithRow,
  requestTo,
} from "../../../../components/action-buttons/ActionButtonGenerator";
import FormikForm from "../../../../components/crud/FormikForm";
import ListComponent from "../../../../components/list/ListComponent";
import TextArea from "../../../../components/form-fields/TextArea";
import Select from "../../../../components/form-fields/Select";
import FileUpload from "../../../../components/fields/FileUpload";
import TextInput from "../../../../components/form-fields/TextInput";
import { formatListWithParameter, formatDate } from "../../../../utils";
import { useTranslation } from "react-i18next";
import { Button } from 'react-bootstrap';

export default function Documents(props) {
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [digerTextboxVisibility, setDigerTextboxVisibility] = useState(false);
  const { t } = useTranslation();
  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepId: props.selectedRow.id,
      evrakTipId: values.evrakTipId,
      fileIds: values.fileIds ? values.fileIds.map((f) => f.id) : [],
      evrakText: values.evrakText,
    };
    if (props.masrafMi) {
      payload.masrafMi = true;
    }
    return payload;
  };

  const endPoint = props.masrafMi ? "yonlendirilecek-talep/masraf-dokuman-ekle" : "yonlendirilecek-talep/dokuman-ekle";

  const listParams = {
    id: props.selectedRow.id
  };

  if (props.masrafMi) {
    listParams.others = {
      masrafMi: true
    };
  }

  // const mapNativeDataBeforeList = (data) => {
  //   return data.talepDosyaFileList
  //     .map((td) => {
  //       return {
  //         createdDate: td.createdDate,
  //         cUser: td.cuser.fullName,
  //         fileName: td.fileName,
  //         id: td.id,
  //       };
  //     })
  //     .concat(
  //       data.dokumanEntityList.map((d) => {
  //         return {
  //           evrakTipi: d.evrakTipi.name,
  //           createdDate: d.createdDate,
  //           cUser: d.userDto.fullName,
  //           ...d.files[0],
  //         };
  //       })
  //     );
  // };

  return (
    <div className="row">
      <div className="col-md-12 col-xl-12 col-xxl-12">
        <FormikForm
          keyField={"documentForm"}
          endPointUrl={endPoint}
          fetchPointUrl=""
          editPointUrl=""
          configParameterName="talepTurId"
          configParameterValue={
            props.selectedRow && props.selectedRow.talepTurId
          }
          configReqType={"POST"}
          configPointUrl="yonlendirilecek-talep/config-evrak"
          arrangeBeforePersist={arrangeBeforePersist}
          setConfigData={(data) => setConfigData(data)}
          initialValues={initialValues}
          validationSchema={validationSchema}
          refreshList={() => setRefreshList(!refreshList)}
          okButtonText={t("tabs.ekle")}
          hideFooterHr
          disableButtons={props.disableButtons}
          resetAfterSubmit={true}
        >
          <div className="form-group col-md-6">
            <Field
              name="evrakTipId"
              label={t("tabs.evrakTipi")}
              buttonLabel = {
                <>
                  <Button
                    className="btn-xs ml-3 px-2 py-1 rounded-circle"
                    variant="primary"
                    onClick={() => setDigerTextboxVisibility(!digerTextboxVisibility)}
                  >
                      <i className={ "fa fa-" + (digerTextboxVisibility ? "minus" : "plus") }/>
                  </Button>
                </>
              }
              colNumber="-6"
              component={Select}
              options={configData && configData.evrakTuru1}
            />
            {digerTextboxVisibility && (
              <Field
                name="evrakText"
                label={t("tabs.digerEvrakTipi")}
                colNumber="-6 hide-label"
                component={TextInput}
              />
            )}
          </div>
          <Field
            name="fileIds"
            label="Dosya"
            colNumber="12"
            component={FileUpload}
          />
        </FormikForm>
      </div>

      <div className="col-md-12">
        <ListComponent
          entityName=""
          endpoint="yonlendirilecek-talep/dokuman-listele"
          keyField="id"
          fileNameField="fileName"
          isMultiSelect={true}
          refreshList={refreshList}
          defaultPageSize={9999}
          // mapNativeDataBeforeList={mapNativeDataBeforeList}
          customBody={listParams}
          columns={[
            {
              dataField: "evrakTipi.shrtCode",
              text: t("tabs.evrakTipi"),
              sort: true,
            },
            {
              dataField: "evrakText",
              text: t("tabs.evrakTipiAciklamasi"),
              sort: true,
            },
            {
              dataField: "fileName",
              text: t("tabs.dosyaAdi"),
              sort: true,
            },
            {
              dataField: "createdDate",
              text: t("tabs.tarih"),
              formatter: formatDate,
              sort: true,
            },
            {
              dataField: "cuser.fullName",
              text: t("tabs.ekleyen"),
              sort: true,
            },
          ]}
          actionButtonsObject={{
            actions: [
              /* requestTo(ABT.DELETE, "file/delete"), */
              addActiveFn(
                requestTo(ABT.DELETE, "file/delete"),
                (row) => !props?.selectedRow?.sadeceSirketYetkilisi
              ),
              requestTo(ABT.DOWNLOAD_MULTIPLE, "file/download"),
              requestTo(
                addActiveFn(ABT.PREVIEW, (row) => row.extension == ".pdf"),
                "file/download"
              ),
            ],
            generator: DefaultActionButtonGenerator,
          }}
        />
      </div>
    </div>
  );
}
